import React from 'react';
import ReactDOM from 'react-dom';
import AppLoader from './AppLoader';
import RumErrorBoundary from './components/RumErrorBoundary/RumErrorBoundary';
import { initRum } from './rum';
import 'semantic-ui-css/semantic.min.css';

// eslint-disable-next-line jest/require-hook
initRum();

// eslint-disable-next-line jest/require-hook
ReactDOM.render(
  <RumErrorBoundary>
    <AppLoader />
  </RumErrorBoundary>,
  document.getElementById('root'),
);
